import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { EquipmentProductExtendedListResponse, ProductExtended, ProductExtendedListResponse, ProductQueryParams } from '@frontend/product/types';

export class ProductExtendedClient extends APIClient {
    public static readonly endpoint = '/product-api/ext/v1';

    public static async fetchExtendedProducts(queryParams?: ApiQueryParams<ProductQueryParams>): Promise<ProductExtendedListResponse> {
        return await this.apiPaginated<ProductExtendedListResponse, ProductQueryParams>(`${this.endpoint}/products`, queryParams);
    }

    public static async fetchExtendedProduct(accountId: string, productId: string): Promise<ProductExtended> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/products/${productId}`);
        return await this.handleResponse<ProductExtended>(response);
    }

    public static async fetchEquipmentsByProductExtended(queryParams?: ApiQueryParams<ProductQueryParams>): Promise<EquipmentProductExtendedListResponse> {
        return await this.apiPaginated<EquipmentProductExtendedListResponse, ProductQueryParams>(`${this.endpoint}/equipments`, queryParams);
    }
}
